import styled from "styled-components";

const ButtonMove = styled.button`
  padding: 5px;
  font-size: 18px;
  color: #444;
  border: 0 none;
  border-radius: 0;
  background-color: transparent;
  cursor: pointer;
`;

export default ButtonMove;
